import { render, staticRenderFns } from "./groupTypeForm.vue?vue&type=template&id=417e6407&"
import script from "./groupTypeForm.vue?vue&type=script&lang=js&"
export * from "./groupTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./groupTypeForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports